import { generatePKCE, generateState } from "@/utils/pkce";

export const handleSalesforceConnection = async () => {
  const clientId = process.env.REACT_APP_SALESFORCE_CLIENT_ID;
  const salesforceBaseUrl = process.env.REACT_APP_SALESFORCE_BASE_URL;
  const redirectUri = `${window.location.origin}/salesforce/callback`;

  const { verifier, challenge } = await generatePKCE();
  const state = generateState();

  sessionStorage.setItem("sf_pkce_verifier", verifier);
  sessionStorage.setItem("sf_oauth_state", state);

  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId ?? "",
    redirect_uri: redirectUri,
    code_challenge: challenge,
    code_challenge_method: "S256",
    state,
  });

  window.location.href =
    `${salesforceBaseUrl}/services/oauth2/authorize?` + params.toString();
};

export const handleHubspotConnection = () => {
  const clientId = process.env.REACT_APP_HUBSPOT_CLIENT_ID;
  const hubspotAppBaseUrl =
    process.env.REACT_APP_HUBSPOT_APP_BASE_URL ?? "https://app.hubspot.com";
  const hubspotScopes = process.env.REACT_APP_HUBSPOT_SCOPES ?? "";

  const redirectUri = `${window.location.origin}/hubspot/callback`;
  const state = generateState();
  sessionStorage.setItem("hubspot_oauth_state", state);

  const params = new URLSearchParams({
    client_id: clientId ?? "",
    redirect_uri: redirectUri,
    scope: hubspotScopes,
    state,
  });

  window.location.href =
    `${hubspotAppBaseUrl}/oauth/authorize?` + params.toString();
};

export const handleStripeConnection = () => {
  const clientId = process.env.REACT_APP_STRIPE_CLIENT_ID;
  const stripeBaseUrl = process.env.REACT_APP_STRIPE_BASE_URL;
  const redirectUri = `${window.location.origin}/stripe/callback`;

  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId ?? "",
    scope: "read_write",
    redirect_uri: redirectUri,
  });

  window.location.href =
    `${stripeBaseUrl}/oauth/authorize?` + params.toString();
};

export const handleQontoConnection = () => {
  const clientId = process.env.REACT_APP_QONTO_CLIENT_ID;
  const qontoBaseUrl =
    process.env.REACT_APP_QONTO_BASE_URL ?? "https://oauth.qonto.com";
  const qontoScopes =
    process.env.REACT_APP_QONTO_SCOPES ??
    "membership.read client_invoices.read offline_access";
  const redirectUri = `${window.location.origin}/qonto/callback`;
  const state = generateState();
  sessionStorage.setItem("qonto_oauth_state", state);

  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId ?? "",
    redirect_uri: redirectUri,
    scope: qontoScopes,
    state,
  });

  window.location.href = `${qontoBaseUrl}/oauth2/auth?` + params.toString();
};
